import { useEffect } from 'react';
import { useDiagnosesPage } from '../contexts/DiagnosesPageContext';
import { useSymptoms } from '../contexts/SymptomsContext';
import { ComponentsCallback } from '../initComponents';

export const useDiagnosticComponentCallbacks = () => {
  const componentsCallback: ComponentsCallback = (window as any)
    .__componentsCallback;
  const { /*selectedDiagnoses, */ selectedSymptomsObj } = useDiagnosesPage();

  const { symptoms } = useSymptoms();

  useEffect(() => {
    if (!selectedSymptomsObj || !Object.keys(selectedSymptomsObj).length)
      return;
    if (!symptoms || !symptoms.length) return;
    componentsCallback(
      'symptomsChanged',
      Object.keys(selectedSymptomsObj).map((id) => {
        const symptom = symptoms.find((s) => s.Id === Number(id));
        return {
          id: Number(id),
          name: symptom?.Name || '',
          required: selectedSymptomsObj[id],
        };
      })
    );
  }, [selectedSymptomsObj, symptoms, componentsCallback]);
};
